interface FatalErrorProps {
  message: string;
}

export function FatalError({ message }: FatalErrorProps) {
  return (
    <div className="py-6 text-center">
      <p className="text-sm font-medium text-gray-900">Unable to connect</p>
      <p className="mt-2 text-sm text-gray-500">{message}</p>
    </div>
  );
}
